$('.c-checkbox').on('click', '.common-tooltip', function(e) {
  console.log('click');
  e.preventDefault();
  // e.stopPropagation();
})

// class CommonTooltip {
//   constructor(el, options) {
//     this.el = $(el);
//     this.breakpoint = options?.breakpoint || 768

//     this.addEventListeners();
//   }

//   addEventListeners() {
//     $(document).on('mouseenter', el, function() {
//       if ($(window).outerWidth() > 767) return;

//       $(el).find('.common-tooltip-block').addClass('is--visible');
//     })
//   }
// }

// const tooltip = new CommonTooltip('.common-tooltip', {
//   breakpoint: 1280,
// });
let commonTooltip;

$(document).on('mouseenter', '.common-tooltip', function(e) {
  if ($(window).outerWidth() < 768) return;
  $(this).find('.common-tooltip-block').addClass('is--visible');
})

$(document).on('mouseleave', '.common-tooltip', function(e) {
  if ($(window).outerWidth() < 768) return;

  $(this).find('.common-tooltip-block').removeClass('is--visible');
})

$(document).on('click', '.common-tooltip', function(e) {
  console.log($(e.target).closest('.common-tooltip__btn'))
  if ($(window).outerWidth() > 767 || !$(e.target).closest('.common-tooltip__btn').length) return;

  commonTooltip = $(this).find('.common-tooltip-block').clone();

  $('body').append(commonTooltip);
  commonTooltip.addClass('is--visible')

  // $(this).find('.common-tooltip-block').addClass('is--visible');
})

$(document).on('click', '.common-tooltip-block', function(e) {
  console.log($(e.target));
  if ($(e.target).closest('.common-tooltip__close').length || !$(e.target).closest('.common-tooltip-block__inner').length) {
    commonTooltip.remove();

    console.log(commonTooltip);
  }
})

$(window).on('scroll', function() {
  $('.common-tooltip-block').removeClass('is--visible');
})
